var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartBag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26147 0.131104C9.2267 0.131152 10.8201 1.72446 10.8201 3.6897V4.4895H11.2673C12.1466 4.48957 12.8897 5.14204 13.0037 6.01392L14.073 14.2004C14.2099 15.2487 13.3938 16.178 12.3367 16.178H2.03979C0.956567 16.1778 0.13311 15.2042 0.313232 14.136L1.69409 5.94946C1.83633 5.10681 2.56604 4.4895 3.42065 4.4895H3.70288V3.6897C3.70288 1.72443 5.29621 0.131104 7.26147 0.131104ZM3.42065 5.22778C2.92611 5.22778 2.50386 5.58483 2.42163 6.07251L1.04077 14.259C0.936773 14.8769 1.4132 15.4405 2.03979 15.4407H12.3367C12.9483 15.4407 13.4207 14.9026 13.3416 14.2961L12.2722 6.10962C12.2063 5.60515 11.7761 5.22785 11.2673 5.22778H10.8201V6.85669C10.8201 7.06043 10.6547 7.2258 10.4509 7.22583C10.2472 7.22583 10.0818 7.06045 10.0818 6.85669V5.22778H4.44116V6.85669C4.44116 7.06041 4.27573 7.22577 4.07202 7.22583C3.86826 7.22583 3.70288 7.06045 3.70288 6.85669V5.22778H3.42065ZM7.26147 0.868408C5.70373 0.868408 4.44116 2.13197 4.44116 3.6897V4.4895H10.0818V3.6897C10.0818 2.132 8.81916 0.868457 7.26147 0.868408Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBag);
export default __webpack_public_path__ + "static/media/cart-bag.4364e490ed4858fda10c6e6de88e4880.svg";
export { ForwardRef as ReactComponent };